package org.hs_soft.runmynesto.pages.home.sub_page.user.mvi

import org.hs_soft.runmynesto.domain.model.home.template.GridItemsFilterEnum
import org.hs_soft.runmynesto.domain.model.home.user.single_user.GetUser
import org.hs_soft.runmynesto.domain.model.home.user.users_info.UserModel
import org.hs_soft.runmynesto.domain.model.home.user.UserCancellationReasonEnum
import org.hs_soft.runmynesto.domain.model.home.user.UserInfoHeaderEnum
import org.hs_soft.runmynesto.domain.model.home.user.tabs.user_checkout.user_checkout_model.Children

data class UserState(
    val selectedTab: UserInfoHeaderEnum = UserInfoHeaderEnum.GENERAL,
    val addNewUserLoading:Boolean=false,
    val selectedUser: GetUser?=null,
    val usersInfo:List<UserModel> = listOf(),
    val cashList: List<Children> ?= null,
    val errorInfo:String?=null,
    val cancellationReason: UserCancellationReasonEnum =
        UserCancellationReasonEnum.NO_AUTHORIZATION,
    val userInfoDetailPasswordVisibility:Boolean=false,
    val isNumberSortedAsc:Boolean=false,
    val checkOutExpandAll:Boolean=false,
    val checkOutSearchValue:String="",
    val isNameSortedAsc:Boolean=true,
    val showNumberSortIcon:Boolean=true,
    val showTitleSortIcon:Boolean=false,
    val searchValue:String="",
    val imgUrl:String ?=null,
    val firstPageActive:Boolean=true,
    val loadingProgress:Boolean=false,
    val showAddRecordDialog:Boolean=false,
    val newRecordName:String="",
    val newRecordNumber:String="",
    val isAddNewRecordSubmitClickable:Boolean=false,
    val addRecordErrorMessage:String="",
    val showUserItemsFilterComponent:Boolean=false,
    val selectedUserFilterItemsType: GridItemsFilterEnum = GridItemsFilterEnum.ACTIVE_ITEMS,

    )